const MethodTypes = {
  GET: 'Get',
  POST: 'Post',
  PUT: 'Put',
  DELETE: 'Delete',
};

export default MethodTypes;
